import { AuthLayout } from "@Layouts";
import { createRoute, redirect } from "@tanstack/react-router";
import { Dashboard, Root } from "@Routes";
import { LoginPage } from "@Elements";
import { z } from "zod";

export const AuthenticationBaseRoute = createRoute({
  getParentRoute: () => Root.RootRoute,
  id: "AuthenticationBaseRoute",
  component: AuthLayout,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({
        to:
          search.redirect || Dashboard.Routes.Home.DashboardHomeRoute.fullPath,
      });
    }
  },
});

export const LoginRoute = createRoute({
  getParentRoute: () => AuthenticationBaseRoute,
  path: "/login",
  component: LoginPage,
  staticData: {
    TITLE: "COMMON.LOGIN",
  },
});

export const AuthenticationRouteTree = AuthenticationBaseRoute.addChildren([
  LoginRoute,
]);
